import React from 'react';
import addMinutes from 'date-fns/addMinutes';
import endOfDay from 'date-fns/endOfDay';
import formatDate from 'date-fns/format';
import isBefore from 'date-fns/isBefore';
import parse from 'date-fns/parse';
import startOfDay from 'date-fns/startOfDay';

import { Trans } from '@lyearn/i18n';

import {
  CronFrequencyEnum,
  CustomFrequencyEnum,
  ScheduleInfoInput,
} from '../../../../types/schema';
import { FORMAT_12H, FORMAT_24H } from '../../../TimePicker';
import { OrderedMonthsOfYear } from './conts';

interface TimeSelectorOptionsParams {
  value: Date;
  timeInterval: number;
  timeformat: string;
}

export const getDayOfMonthAndMonthOfYear = (selectedTime?: string | null) => {
  const newDate = selectedTime ? new Date(selectedTime) : new Date();
  const dayOfMonth = newDate.getDate();
  const monthOfYear = OrderedMonthsOfYear[newDate.getMonth()];
  return { dayOfMonth, MonthOfYear: monthOfYear };
};

export const getTimeSelecterOptions = (params: TimeSelectorOptionsParams) => {
  const { timeformat, timeInterval, value } = params;

  const timeSelectorOptions = [];

  let timeSelectorValue = startOfDay(value);
  const endOfDayValue = endOfDay(value);

  do {
    timeSelectorOptions.push({
      value: timeSelectorValue,
      label: formatDate(timeSelectorValue, timeformat),
    });
    timeSelectorValue = addMinutes(timeSelectorValue, timeInterval);
  } while (isBefore(timeSelectorValue, endOfDayValue));

  return timeSelectorOptions;
};

export const convertTo12HourFormat = (time: string) => {
  if (!time) {
    return '';
  }
  return formatDate(parse(time, FORMAT_24H, new Date()), FORMAT_12H);
};

export type ScheduleInfoErrorConfig = {
  daysOfWeek?: JSX.Element;
  weeksOfMonth?: JSX.Element;
};
export const validateScheduleInfo = (scheduleInfo: ScheduleInfoInput) => {
  const errorConfig: ScheduleInfoErrorConfig = {};

  const DaysOfWeek = <Trans i18nKey="1on1s:Modal.DaysOfWeek" />;
  const WeeksOfMonth = <Trans i18nKey="1on1s:Modal.WeeksOfMonth" />;

  switch (scheduleInfo.frequency) {
    case CronFrequencyEnum.Daily:
      break;
    case CronFrequencyEnum.Weekly:
    case CronFrequencyEnum.Fortnightly: {
      if (!scheduleInfo.daysOfWeek?.length && !scheduleInfo.dayOfWeek) {
        errorConfig.daysOfWeek = DaysOfWeek;
      }
      break;
    }
    case CronFrequencyEnum.Monthly:
    case CronFrequencyEnum.Quarterly: {
      if (!scheduleInfo.weeksOfMonth?.length && !scheduleInfo.weekOfMonth) {
        errorConfig.weeksOfMonth = WeeksOfMonth;
      }
      if (!scheduleInfo.daysOfWeek?.length && !scheduleInfo.dayOfWeek) {
        errorConfig.daysOfWeek = DaysOfWeek;
      }
      break;
    }
    case CronFrequencyEnum.Yearly:
      break;
    case CronFrequencyEnum.Custom: {
      switch (scheduleInfo.custom?.frequency) {
        case CustomFrequencyEnum.Day:
          break;
        case CustomFrequencyEnum.Week: {
          if (!scheduleInfo.custom.daysOfWeek?.length) {
            errorConfig.daysOfWeek = DaysOfWeek;
          }
          break;
        }
        case CustomFrequencyEnum.Month: {
          if (!scheduleInfo.custom?.weeksOfMonth?.length && !scheduleInfo.custom?.weekOfMonth) {
            errorConfig.weeksOfMonth = WeeksOfMonth;
          }
          if (!scheduleInfo.custom?.daysOfWeek?.length) {
            errorConfig.daysOfWeek = DaysOfWeek;
          }
          break;
        }
        case CustomFrequencyEnum.Year:
          break;
      }
      break;
    }
  }

  return Object.keys(errorConfig).length ? errorConfig : undefined;
};
